import { render, staticRenderFns } from "./DocumentPowerpointDocument.vue?vue&type=template&id=d56a5ed4&scoped=true"
import script from "./DocumentPowerpointDocument.vue?vue&type=script&lang=js"
export * from "./DocumentPowerpointDocument.vue?vue&type=script&lang=js"
import style0 from "./DocumentPowerpointDocument.vue?vue&type=style&index=0&id=d56a5ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56a5ed4",
  null
  
)

export default component.exports